import ShareProfileButton from "./ShareProfileButton";

export default ShareProfileButton;
